// 繁体中文
export default {
    /* 登录、注册 =======================================================0 */
    "登录": "登入",
    "注册": "註冊",
    "忘记密码": "忘記密碼?",
    "没有账号？马上注册": "沒有帳號？馬上註冊",
    "请输入手机号": "請輸入手機號碼",
    "请输入密码": "請輸入密碼",
    "请确认密码": "請確認密碼",
    "请输入邀请码": "請輸入邀請碼",
    "密码确认失败，请重新设置": "密碼確認失敗，請重新設定",
    "登录中...": "登入中...",
    "登录成功": "登入成功",
    "注册中...": "註冊中...",
    "注册成功,即将跳转首页": "註冊成功,即將跳轉首頁",
    "我已经知晓并同意开户协议各项条约": "我已經知道並同意開戶協議各項條約",
    "请阅读并同意开户协议": "請閱讀並同意開戶協議",
    "已有账号？马上登录": "已有帳號？馬上登入",
    "请联系在线客服": "請聯絡線上客服",
    /* 登录、注册 =======================================================1 */

    /* 首页 ============================================================0 */
    "首页": "首頁",
    "请选择地区": "請選擇地區",
    "全国第一福利品": "全國第一福利品",
    "为了会员权益，网站只展示 1% 资源并且不定期更新只为展示实力，如需查询预约更多资源请联系上级接待": "為了會員權益，網站只展示 1% 資源並且不定期更新只為展示實力，如需查詢預約更多資源請聯繫上級接待",
    "本平台所有资源真实、安全、可靠，全国空降、同城约炮选取你心仪的她，与您零距离邂逅，快加入我们吧": "本平台所有資源真實、安全、可靠，全國空降、同城約炮選取你心儀的她，與您零距離吧，快加入我們邂逅吧!",
    "平台资源": "平台資源",
    "昵称": "暱稱:",
    "类型": "類型:",
    "距离：点击查看": "距離：點擊查看",
    "服务项目：激活可见": "服務項目：啟動可見",
    "已认证": "已認證",
    "查看更多": "看更多",
    "当前地区暂无资源": "目前地區暫無資源",
    "服务条款": "服務條款",
    "网红、模特、空姐、嫩模、大学生、留学生，只有您想不到，没有本平台办不到": "網紅、模特兒、空姐、嫩模、大學生、留學生，只有您想不到，沒有本平台辦不到。",
    "服务范围": "服務範圍",
    "同城约炮，任意地点空降，国内一二线城市当地均有，三线城市也可以通过上级预约安排": "同城約炮，任意地點空降，國內一二線城市當地均有，三線城市也可以透過上級預約安排。",
    "热门地区": "熱門地區",
    "更多地区": "更多地區",
    "网红、模特、空姐、嫩模、大学生、留学生": ['網紅', '模特兒', '空姐', '嫩模', '大學生', '留學生'],
    "请联系管理员激活账号": "請聯絡管理員啟動帳號",
    "请联系客服获取更多信息": "請聯絡客服以取得更多資訊",
    /* 首页 ============================================================1 */

    /* 福利 ============================================================0 */
    "福利": "福利",
    "全部": "全部",
    /* 福利 ============================================================1 */

    /* 视频 ============================================================0 */
    "视频": "影片",
    /* 视频 ============================================================1 */

    /* 我的 ============================================================0 */
    "我的": "我的",
    "余额": "餘額",
    "元": "元",
    "¥": "¥",
    "CNY": "CNY",
    "我的信用分": "我的信用分",
    "我的客服": "我的客服",
    "提现": "提現",
    "提现记录": "提現記錄",
    "个人报表": "個人報表",
    "任务记录": "任務記錄",
    "我的消息": "我的消息",
    "银行卡": "銀行卡",
    "设置": "設定",
    "未配置跳转链接": "未設定跳轉連結",
    "功能尚未开放": "功能尚未開放",
    /* 我的 ============================================================1 */

    /* 美女 ============================================================0 */
    "公告": "公告",
    "基本信息": "基本資訊",
    "生日": "生日: **** 年 ** 月 ** 日",
    "身高": "身高: ***cm",
    "体重": "體重: ***kg",
    "胸围": "胸圍: ***",
    "所在位置：已隐藏，联系客服激活可见": "位置：已隱藏，聯絡客服啟動可見。",
    "联系方式：已隐藏，联系客服激活可见": "聯絡方式：已隱藏，聯絡客服啟動可見。",
    "服务项目：激活可见": "服務項目：啟動可見。",
    "祝愿各位会员每天都能遇到美好的恋情，享受快乐的夜晚": "祝福各位會員每天都能遇到美好的戀情，享受快樂的夜晚!",
    "立即约她": "立即約她",
    "联系专属客服接待": "聯絡專屬客服接待",
    /* 美女 ============================================================1 */

    /* 个人报表 ========================================================0 */
    "盈利金额": "獲利金額",
    "盈利计算公式": "獲利計算公式",
    "任务金额": "任務金額",
    "充值金额": "儲值金額",
    "提现金额": "提現金金額",
    "中奖金额": "中獎金額",
    /* 个人报表 ========================================================1 */

    /* 播放器 ==========================================================0 */
    "播放器": "播放器",
    "热门推荐": "熱門推薦",
    "提示": "提示",
    "播放次数已用完，请联系专属客服": "播放次數已用完，請聯絡專屬客服",
    /* 播放器 ==========================================================1 */

    /* 下注 ===========================================================0 */
    "彩票": "樂透",
    "查看历史开奖": "查看歷史開獎",
    "开奖期数": "開獎期數",
    "中奖号码": "中獎號碼",
    "下单": "下單",
    "下注号码": "下注號碼",
    "请选择下注号码": "請選擇下注號碼",
    "每注金额": "每註金額",
    "请输入金额": "請輸入金額",
    "总计": "總計",
    "订单": "訂單",
    "清空": "清空",
    "余额不足，请联系客服充值": "餘額不足，請聯絡客服儲值",
    "付款功能未开通，请联系在线客服": "付款功能未開通，請聯絡線上客服",
    "付款中...": "付款中...",
    "付款成功": "付款成功",
    /* 下注 ===========================================================1 */

    /* 任务记录 =======================================================0 */
    "暂无记录": "暫無紀錄",
    "待开奖": "待開獎",
    "订单金额": "訂單金額:",
    "中奖金额": "中獎金額:",
    "下注时间": "下注時間:",
    "开奖时间": "開獎時間:",
    "隐藏详情": "隱藏詳情",
    "查看详情": "查看詳情",
    "投注号码": "投注號碼:",
    "投注金额": "投注金額:",
    /* 任务记录 =======================================================1 */

    /* 银行卡 =========================================================0 */
    "银行名称": "銀行名稱",
    "银行卡号": "銀行卡號",
    "持卡人姓名": "持卡人姓名",
    "手机号": "手機號碼",
    "点击选择银行": "點選選擇銀行",
    "请填写银行卡号": "請填寫銀行卡號碼",
    "请填写持卡人姓名": "請填寫持卡人姓名",
    "请填写预留手机号": "請填寫預約手機號碼",
    "添加银行卡": "新增銀行卡",
    "绑定银行卡": "綁定銀行卡",
    "提示:请绑定大型商业银行, 如需修改, 请您联系在线客服": "提示:請綁定大型商業銀行, 如需修改, 請您聯絡線上客服。",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "尊敬的用戶,為了保障您的資金安全,請您綁定您的真實姓名和設置取款密碼,如果姓名與開戶名不一致,將無法取款。",
    "请绑定大型商业银行, 如需修改, 请您联系在线客服": "請綁定大型商業銀行, 如需修改, 請您聯絡線上客服。",
    /* 银行卡 =========================================================1 */

    /* 提现 ===========================================================0 */
    "记录": "提現記錄",
    "限额说明": "限額說明",
    "单笔交易最低限额": "單筆交易最低限額",
    "单笔交易最高限额": "單筆交易最高限額",
    "每天可提款次数": "每日可提款次數",
    "到账时间": "到帳時間：一般在 5 分鐘左右，但最快可達 2 分鐘。",
    "请输入资金密码": "請輸入資金密碼",
    "请联系专属客服": "請聯絡專屬客服",
    "取消": "取消",
    "提交中...": "提交中...",
    "说明": "說明",
    "提交时间": "提交時間",
    "审核时间": "審核時間",
    "审核中": "審核中",
    "请设置提现密码以及绑定银行卡，否则无法使用提现功能": "請設定提現密碼以及綁定銀行卡，否則無法使用提現功能",
    "设置提现密码": "設定提現密碼",
    "返回": "返回",
    "请绑定银行卡，否则无法使用提现功能": "請綁定銀行卡，否則無法使用提現功能",
    "绑定银行卡": "綁定銀行卡",
    /* 提现 ===========================================================1 */

    /* 设置 ===========================================================0 */
    "头像": "頭像",
    "点击选择头像": "點選選擇頭像",
    "姓名": "姓名",
    "点击设置姓名": "點擊設定姓名",
    "性别": "性别",
    "男": "男",
    "女": "女",
    "未知": "未知",
    "点击选择性别": "點選選擇性別",
    "登录密码": "登入密碼",
    "去修改": "去修改",
    "资金密码": "資金密碼",
    "如需修改，请联系专属客服": "如需修改，請聯絡專屬客服",
    "设置动词": "設定",
    "语言": "語言",
    "切换语言": "切換語言",
    "退出登录": "退出登入",
    "选择头像": "選擇頭像",
    "确定": "確定",
    "设置姓名": "設定姓名",
    "请输入您的姓名": "請輸入您的姓名",
    "请选择您的性别": "請選擇您的性別",
    "你已设置姓名，如需修改，请联系专属客服": "你已設定姓名，如需修改，請聯絡專屬客服。",
    /* 设置 ===========================================================1 */

    /* 选择语言 ===========================================================0 */
    "选择语言": "選擇語言",
    "正在切换语言...": "正在切換語言...",
    /* 选择语言 ===========================================================1 */

    /* 修改登录密 =========================================================0 */
    "修改登录密码": "修改登入密碼",
    "旧密码": "舊密碼",
    "请输入旧密码": "請輸入舊密碼",
    "新密码": "新密碼",
    "请输入新密码": "請輸入新密碼",
    "确认密码": "確認密碼",
    "请确认新密码": "請確認新密碼",
    "修改": "修改",
    "修改中...": "修改中...",
    "修改成功，请重新登录": "修改成功，請重新登入",
    /* 修改登录密 =========================================================1 */

    /* 设置资金密码 =======================================================1 */
    "设置资金密码": "設定資金密碼",
    "资金密码必须由四位数字组成": "資金密碼必須由四位數組成",
    "设置中...": "設定中...",
    "设置成功": "設定成功",
    /* 设置资金密码 =======================================================1 */
}